export const checkPasswordStrength = (password: string) => {
    let strength = 0;
    if (password.length >= 1) strength += 1;
    if (/[A-Z]/.test(password) && password.length >= 8) strength += 1;
    if (/[0-9]/.test(password) && password.length >= 8) strength += 1;
    if (/[^A-Za-z0-9]/.test(password) && password.length >= 8) strength += 1;
    return strength;
};

export const getProgressColor = (passwordStrength: number) => {
    switch (passwordStrength) {
        case 1:
            return '#ff4d4f';
        case 2:
            return '#faad14';
        case 3:
            return '#52c41a';
        case 4:
            return '#1890ff';
        default:
            return 'gray';
    }
};